import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'

import ProviderTile from '../ProviderTile'

import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'

type Props = {
  provider: Provider
  className?: string
  category?: string
  gameIndex?: number
}

export default function ProviderTileContainer(props: Props) {
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)

  return (
    <ProviderTile className={props.className} role='link' provider={props.provider} activeCurrency={activeCurrency} />
  )
}
